$.fn.imageInput = function(options){
    var defaults = {
      obj: $(this),
      multiple: false
    }
    var settings = $.extend(defaults, options);
  
    settings.obj.on("change", (e) => {
        var inputs = e.target.files;


        if (inputs) {
            settings.obj.addClass("active"); 
            settings.obj.siblings(".imageInput").empty();

            for (var i = 0; i < inputs.length ; i++) {
                var reader = new FileReader();
                reader.onload = function(e) {
                    var name = e.target.fileName;
                    var image = e.target.result;
                    var previewDom = '<img src="'+image+'" alt="'+name+'" />';
                    settings.obj.siblings(".imageInput").append(previewDom);
                    settings.obj.attr('data-base64',reader.result);
                }
                reader.fileName = inputs[i].name;
                reader.readAsDataURL(inputs[i]);
            }
        }
    })

  }
